import type { PropsWithChildren } from 'react'

export default function AppScreen({ children }: PropsWithChildren) {
  return (
    <div className="flex min-h-screen w-full flex-row bg-[linear-gradient(135deg,var(--color-white),var(--color-primary-300))]">
      {children}
    </div>
  )
}
